import ladder_pencil from '@/assets/images/ladder_pencil.png'
import { Flex, Typography } from 'antd'

const { Title, Text } = Typography

const StepTwo = () => {
  return (
    <Flex vertical gap="middle" align="center">
      <img src={ladder_pencil} alt="Ladder Pencil" width={178} />

      <Title
        level={1}
        style={{ fontWeight: 'bold', margin: 0, textAlign: 'center' }}
      >
        Sua assinatura foi cancelada
      </Title>
      <Text
        type="secondary"
        style={{ fontSize: '16px', textAlign: 'center', maxWidth: '75%' }}
      >
        Seus limites de conta foram atualizados. Se quiser ir mais longe, confira nossos planos
      </Text>
    </Flex>
  )
}

export default StepTwo
